import configServices from "../../../../utils/configServices";
// import { IRoleGroupResponseModel, IPermissionGroupResponseModel, any, IRoleGroupModel } from "../role.model";

// export const createRole = async (body: {}) => {
//   const result = await configServices.postService<any>("role", {
//     ...body,
//   });
//   return result;
// };

// export const deleteRole = async (id: number) => {
//   const result = await configServices.deleteService<any>(
//     `role/${id}`
//   );
//   return result;
// };
// export const getRoleDetail = async (id: number) => {
//   const result = await configServices.getService<any>(
//     `role/${id}`
//   );
//   return result;
// };

// export const updateRole = async (id: number, param: any) => {
//   const result = await configServices.patchService<any>(
//     `role/${id}`,
//     { ...param }
//   );
//   return result;
// };


// export const getRole = async () => {
//   const result = await configServices.getService<any>(
//     `user/role`,
//     null,
//     null,
//     true
//   );
//   return result;
// };

// export const getListRoleGroup = async (filter: any) => {
//   const result = await configServices.getService<any>(
//     `role`,
//     filter,
//     null,
//     true
//   );
//   return result;
// };

// export const getListCustomer = async (filter: any) => {
//   const result = await configServices.getService<any>(
//     `SearchBP`,
//     filter,
//     null,
//     true
//   );
//   return result;
// };

//  Get List customer
export const getListCustomerCond = async (body: {}) => {
  const result = await configServices.postService<any>(
    "customer",
    { ...body }
  );
  return result;
};
// Get Detail Customer By MaDoiTac
export const getDetailCustomerByMaDoiTac = async (id: string) => {
  const result = await configServices.postService<any>(
    "customer/detail",
    {id}
  );
  return result;
};
// Get All Group
export const getAllGroup = async () => {
  const result = await configServices.postService<any>(
    "customer/getAllGroup",
    null
  );
  return result;
};